import React from "react"

import TaskTypeIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5"
import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view"
import {BREAKDOWN_ALL_VALUES} from "../../../../../gd-modules/tasks-view/core/@const"

export default function FieldTaskType_QuickFilterView(props: FieldQuickFilterViewProps) {


    let icon    = null
    let label   = 'Unknown'

    switch (props.value) {
        case BREAKDOWN_ALL_VALUES:
            label = 'All task types'
            break
        default:
            icon = <TaskTypeIcon className="group-icon m-r-10" taskTypeId={props.value} size="14"/>
            label = gd.session.taskTypes.get(props.value)!.name
            break
    }

    const classes = Classes("ui5-group-by-view", props.className)

    return (
        <div className={classes}>
            {icon}
            <div className="name">{label}</div>
        </div>
    )




}